export default __webpack_public_path__ + "static/media/virtual-assistant-2.5341889f.svg";